import { useState } from 'react';
import { useI18n } from 'core/i18n/I18nProvider';
import { copyText } from 'features/company/companyUtils';
import { LiveRegion } from 'shared/components/ResultPresentation';

export function CopyButton({ value, label, className = 'btn btn-secondary', announceKey = 'company.codes.copySuccess' }) {
  const { t } = useI18n();
  const [announcement, setAnnouncement] = useState('');

  const handleCopy = async () => {
    const copied = await copyText(value);
    if (copied) {
      setAnnouncement(t(announceKey));
      window.setTimeout(() => setAnnouncement(''), 1500);
    }
  };

  return (
    <>
      <button type="button" className={className} onClick={() => { void handleCopy(); }}>
        {label || t('company.codes.copy')}
      </button>
      <LiveRegion message={announcement} />
    </>
  );
}
